<!-- 饼图 -->
<style lang="stylus" scoped>
.pie {
  width: 100%;
  height: 164px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="pie">
      <div class="main"></div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '新型农业经营主体',
      chartData: [
        { value: 18, name: '龙头企业' },
        { value: 567, name: '农民合作社' },
        { value: 79, name: '家庭农场' },
        { value: 280, name: '农资店' }
      ]
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    const data = this.chartData;
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.pie .main'));
    this.myChart.setOption({
      title: {
        show: false
      },
      legend: [{
        orient: 'vertical',
        // icon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
        left: '10',
        top: '20',
        data: ['龙头企业', '农民合作社', '家庭农场', '农资店'],
        textStyle: {
          color: "#00fefb",
          fontSize: 14
        }
      }, {
        orient: 'vertical',
        icon: "none",
        left: '86',
        top: '20',
        data: ['龙头企业', '农民合作社', '家庭农场', '农资店'],
        formatter: function (name) {
          var oa = data;
          var num = oa[0].value + oa[1].value + oa[2].value + oa[3].value;
          for (var i = 0; i < data.length; i++) {
            if (name === oa[i].name) {
              return oa[i].value;
            }
          }
        },
        textStyle: {
          color: '#fff',
          padding: [2, 0, 0, 0, 0]
        }
      }],
      toolbox: {
        show: false
      },
      color: this.color,
      series: [
        {
          name: '访问来源',
          type: 'pie',
          radius: ['30%', '60%'],
          center: ['70%', '50%'],
          data,
          label: {
            position: 'outside'
          },
          labelLine: {
            show: true
          },
          itemStyle: {
            position: 'outside',
            normal: {
              label: {
                show: true,
                fontSize: 16,
                position: 'outside',
                formatter: '{d}%',
                color: "#fff"
              },
              labelLine: {
                show: true
              }
            },
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    });
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?60430c3f